import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { AclService } from 'ng2-acl/dist';


@Injectable()
export class FuseNavigationService
{
    flatNavigation: any[] = [];

    onItemCollapsed: Subject<any> = new Subject;
    onItemCollapseToggled: Subject<any> = new Subject;

    constructor(private aclService: AclService) {}

    /**
     * Get flattened navigation array
     * @param navigation
     * @returns {any[]}
     */
    getFlatNavigation(navigation)
    {
        for ( const navItem of navigation )
        {
            if ( navItem.type === 'item' )
            {
                if (navItem.permission) {
                    if (this.aclService.can((navItem.permission))) {
                        this.flatNavigation.push({
                            title: navItem.title,
                            type : navItem.type,
                            translate: navItem.translate,
                            icon : navItem.icon || false,
                            url  : navItem.url
                        });
                    }
                } else {
                    this.flatNavigation.push({
                        title: navItem.title,
                        type : navItem.type,
                        translate: navItem.translate,
                        icon : navItem.icon || false,
                        url  : navItem.url
                    });
                }
                continue;
            }

            if ( navItem.type === 'collapse' || navItem.type === 'group' )
            {
                if ( navItem.children )
                {
                    this.getFlatNavigation(navItem.children);
                }
            }
        }
        return this.flatNavigation;
    }

    clearFlatNavigation() {
        this.flatNavigation = []; 
    }
}



// WEBPACK FOOTER //
// ./src/@fuse/components/navigation/navigation.service.ts